import { localize, getLocale } from '../../../util/Localizer'
import { ClaimTypes } from '../../../redux/SubmitClaim/Common'

const getPractitionerTitle = (type, benefitTypes = []) => {
  if (ClaimTypes.isDental(type)) {
    return localize('pages.SubmitAClaim.ExtendedHealthCareProviders.dentist')
  } else if (ClaimTypes.isDrug(type)) {
    return localize('pages.SubmitAClaim.ExtendedHealthCareProviders.pharmacy')
  } else {
    const foundType = benefitTypes.reduce((found, t) => {
      const { extendedHealthCareTypes } = t
      if (Array.isArray(extendedHealthCareTypes)) {
        return extendedHealthCareTypes.find(ehcType => {
          return (ehcType.nameEnglish === type)
        })
      } else {
        return found
      }
    }, null)

    const defaultTitle = (getLocale() === 'fr') ? ClaimTypes.OTHER_EHC_FR : ClaimTypes.OTHER_EHC
    return (foundType) ? foundType.name : defaultTitle
  }
}

const getSearchTitle = (type, benefitTypes = []) => {
  const practitionerTitle = getPractitionerTitle(type, benefitTypes)

  switch (type) {
    case ClaimTypes.DRUG:
    case ClaimTypes.DRUG_FR:
      return localize('pages.SubmitAClaim.Drug.AddPharmacy.Title')
    case ClaimTypes.DENTAL:
    case ClaimTypes.DENTAL_FR:
      return localize('pages.SubmitAClaim.Expenses.Dental.SearchTitle')
    case ClaimTypes.OTHER_EHC:
      return practitionerTitle
    default:
      return `${localize('pages.SubmitAClaim.Practitioner.Title')} ${practitionerTitle}`
  }
}

export {
  getPractitionerTitle,
  getSearchTitle
}



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/Practitioner/functions.js